import styled, { css } from 'styled-components';
import { tabItems } from './ServiceRangeSection';
import MarginBox from '../../MarginBox';

interface Props {
  activeTab: typeof tabItems[number]['name'];
}

export default function TabContents({ activeTab }: Props) {
  return (
    <Container>
      <LivingRoom isActive={activeTab === '거실, 방'} />
      <Kitchen isActive={activeTab === '주방'} />
      <Toilet isActive={activeTab === '화장실'} />
      <Entrance isActive={activeTab === '현관, 쓰레기배출'} />
      <Laundry isActive={activeTab === '세탁, 실내창틀, 베란다'} />
      <NoOfferService isActive={activeTab === '미제공 서비스'} />
    </Container>
  );
}

const Container = styled.div`
  padding: 0 24px;
  padding-top: 50px;
  padding-bottom: 50px;

  min-height: 700px;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    padding-top: 42px;
    min-height: 620px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    padding-top: 40px;
    height: auto;
  }
`;

const LivingRoom = ({ isActive }: { isActive: boolean }) => {
  return (
    <TabContent $isActive={isActive}>
      <FakeTitle>거실, 방</FakeTitle>
      <ServiceTitleWrapper>
        <ServiceTitle>기본 서비스</ServiceTitle>
      </ServiceTitleWrapper>
      <ServiceList>
        <ServiceItem>
          <CheckCircle>{CheckCircleSvg}</CheckCircle>
          <ServiceText>소파, 책상, 화장대 등 가구 위 먼지 제거</ServiceText>
        </ServiceItem>
        <ServiceItem>
          <CheckCircle>{CheckCircleSvg}</CheckCircle>
          <ServiceText>건조된 빨래 개켜서 마무리</ServiceText>
        </ServiceItem>
        <ServiceItem>
          <CheckCircle>{CheckCircleSvg}</CheckCircle>
          <ServiceText>청소기 및 막대걸레로 바닥 청소</ServiceText>
        </ServiceItem>
        <ServiceItem>
          <CheckCircle>{CheckCircleSvg}</CheckCircle>
          <ServiceText>침구 정리정돈</ServiceText>
        </ServiceItem>
        <ServiceItem>
          <CheckCircle>{CheckCircleSvg}</CheckCircle>
          <ServiceText>물건 제자리 정리정돈</ServiceText>
        </ServiceItem>
      </ServiceList>
      <ServiceTitleWrapper>
        <ServiceTitle>유료 추가서비스</ServiceTitle>
      </ServiceTitleWrapper>
      <ServiceList>
        <ServiceItem>
          <CheckCircle bgColor="#2ED1BD">{CheckCircleSvg}</CheckCircle>
          <ServiceText>간단한 다림질 (3장 내외)</ServiceText>
        </ServiceItem>
      </ServiceList>
    </TabContent>
  );
};

const Kitchen = ({ isActive }: { isActive: boolean }) => {
  return (
    <TabContent $isActive={isActive}>
      <FakeTitle>주방</FakeTitle>
      <ServiceTitleWrapper>
        <ServiceTitle>기본 서비스</ServiceTitle>
      </ServiceTitleWrapper>
      <ServiceList>
        <ServiceItem>
          <CheckCircle>{CheckCircleSvg}</CheckCircle>
          <ServiceText>식탁 위 정리 및 설거지</ServiceText>
        </ServiceItem>
        <ServiceItem>
          <CheckCircle>{CheckCircleSvg}</CheckCircle>
          <ServiceText>가스렌지 및 인덕션 위 기름때 제거</ServiceText>
        </ServiceItem>
        <ServiceItem>
          <CheckCircle>{CheckCircleSvg}</CheckCircle>
          <ServiceText>싱크볼 및 거름망 세척</ServiceText>
        </ServiceItem>
      </ServiceList>
      <ServiceTitleWrapper>
        <ServiceTitle>정기 이용시 협의 후 가능</ServiceTitle>
      </ServiceTitleWrapper>
      <ServiceList>
        <ServiceItem>
          <CheckCircle bgColor="#009EB2">{CheckCircleSvg}</CheckCircle>
          <ServiceText>가스 후드 망 청소</ServiceText>
        </ServiceItem>
        <ServiceItem>
          <CheckCircle bgColor="#009EB2">{CheckCircleSvg}</CheckCircle>
          <ServiceText>냉장실 간단 청소</ServiceText>
        </ServiceItem>
      </ServiceList>
      <ServiceTitleWrapper>
        <ServiceTitle>주방 부분 청소시</ServiceTitle>
      </ServiceTitleWrapper>
      <ServiceList>
        <ServiceItem>
          <CheckCircle bgColor="#2ED1BD">{CheckCircleSvg}</CheckCircle>
          <ServiceTextContainer>
            <ServiceText>소형가전 닦기</ServiceText>
            <MarginBox height={6} />
            <ServiceDescription>전자레인지, 에어프라이기, 전기 밥솥, 정수기&커피머신 물받이 등</ServiceDescription>
          </ServiceTextContainer>
        </ServiceItem>
        <ServiceItem>
          <CheckCircle bgColor="#2ED1BD">{CheckCircleSvg}</CheckCircle>
          <ServiceTextContainer>
            <ServiceText>주방 주변부 벽 기름때 제거 및 수납장 겉면 닦기</ServiceText>
            <MarginBox height={6} />
            <ServiceDescription>손 닿는 곳 까지만 가능</ServiceDescription>
          </ServiceTextContainer>
        </ServiceItem>
        <ServiceItem>
          <CheckCircle bgColor="#2ED1BD">{CheckCircleSvg}</CheckCircle>
          <ServiceTextContainer>
            <ServiceText>설거지 후 정리</ServiceText>
            <MarginBox height={6} />
            <ServiceDescription>
              식기세척기 사용 요청 시, 기계 작동만 가능하며, 시간 관계상 정리 및 수납 불가. 단, 식기세척기가 미리
              작동되어 시간 내 건조된 식기는 정리 진행
            </ServiceDescription>
          </ServiceTextContainer>
        </ServiceItem>
        <ServiceItem>
          <CheckCircle bgColor="#2ED1BD">{CheckCircleSvg}</CheckCircle>
          <ServiceTextContainer>
            <ServiceText>후드청소</ServiceText>
            <MarginBox height={6} />
            <ServiceDescription>
              신청한 경우 설거지 수준으로 진행되며, 후드망은 분리된 상태로 건조하여 마무리
            </ServiceDescription>
          </ServiceTextContainer>
        </ServiceItem>
        <ServiceItem>
          <CheckCircle bgColor="#2ED1BD">{CheckCircleSvg}</CheckCircle>
          <ServiceText>선택한 쓰레기 배출 (일반, 음식물)</ServiceText>
        </ServiceItem>
      </ServiceList>
      <Information>
        <InfoDt>부분청소</InfoDt>
        <MarginBox height={8} />
        <InfoDd>냉장실 또는 주방만 단독으로 서비스 받을 수 있습니다.</InfoDd>
      </Information>
    </TabContent>
  );
};

const Toilet = ({ isActive }: { isActive: boolean }) => {
  return (
    <TabContent $isActive={isActive}>
      <FakeTitle>화장실</FakeTitle>
      <ServiceTitleWrapper>
        <ServiceTitle>기본 서비스</ServiceTitle>
      </ServiceTitleWrapper>
      <ServiceList>
        <ServiceItem>
          <CheckCircle>{CheckCircleSvg}</CheckCircle>
          <ServiceText>거울 물때 제거</ServiceText>
        </ServiceItem>
        <ServiceItem>
          <CheckCircle>{CheckCircleSvg}</CheckCircle>
          <ServiceText>전면 선반 청소 후 제자리 정돈</ServiceText>
        </ServiceItem>
        <ServiceItem>
          <CheckCircle>{CheckCircleSvg}</CheckCircle>
          <ServiceText>수전, 세면대, 변기 등 내/외부 청소</ServiceText>
        </ServiceItem>
        <ServiceItem>
          <CheckCircle>{CheckCircleSvg}</CheckCircle>
          <ServiceText>배수구 머리카락 제거 및 청소</ServiceText>
        </ServiceItem>
        <ServiceItem>
          <CheckCircle>{CheckCircleSvg}</CheckCircle>
          <ServiceText>바닥 물기 제거</ServiceText>
        </ServiceItem>
      </ServiceList>
      <Information>
        <InfoDt>부분청소</InfoDt>
        <MarginBox height={8} />
        <InfoDd>화장실만 단독으로 서비스 받을 수 있습니다.</InfoDd>
      </Information>
    </TabContent>
  );
};

const Entrance = ({ isActive }: { isActive: boolean }) => {
  return (
    <TabContent $isActive={isActive}>
      <FakeTitle>현관, 쓰레기배출</FakeTitle>
      <ServiceTitleWrapper>
        <ServiceTitle>기본 서비스</ServiceTitle>
      </ServiceTitleWrapper>
      <ServiceList>
        <ServiceItem>
          <CheckCircle>{CheckCircleSvg}</CheckCircle>
          <ServiceText>바닥 먼지 청소</ServiceText>
        </ServiceItem>
        <ServiceItem>
          <CheckCircle>{CheckCircleSvg}</CheckCircle>
          <ServiceText>일반/음식물/재활용 선택 시 배출</ServiceText>
        </ServiceItem>
        <ServiceItem>
          <CheckCircle>{CheckCircleSvg}</CheckCircle>
          <ServiceText>현관 앞 신발 정리정돈</ServiceText>
        </ServiceItem>
      </ServiceList>
    </TabContent>
  );
};

const Laundry = ({ isActive }: { isActive: boolean }) => {
  return (
    <TabContent $isActive={isActive}>
      <FakeTitle>세탁, 실내창틀, 베란다</FakeTitle>
      <ServiceTitleWrapper>
        <ServiceTitle $color="#00000099">무료 선택 서비스</ServiceTitle>
        <ServiceSubText>
          1회 서비스 이용 시 아래 세 가지 서비스 중 하나를 선택하여 서비스 받을 수 있습니다.
        </ServiceSubText>
      </ServiceTitleWrapper>
      <ServiceList>
        <ServiceItem>
          <CheckCircle bgColor="#009EB2">{CheckCircleSvg}</CheckCircle>
          <ServiceText>분류된 세탁물 세탁 진행 (1회)</ServiceText>
        </ServiceItem>
        <ServiceItem>
          <CheckCircle bgColor="#009EB2">{CheckCircleSvg}</CheckCircle>
          <ServiceText>베란다 바닥 간단청소 (30분)</ServiceText>
        </ServiceItem>
        <ServiceItem>
          <CheckCircle bgColor="#009EB2">{CheckCircleSvg}</CheckCircle>
          <ServiceText>실내창틀 먼지제거 (30분)</ServiceText>
        </ServiceItem>
      </ServiceList>
    </TabContent>
  );
};

const NoOfferService = ({ isActive }: { isActive: boolean }) => {
  return (
    <TabContent $isActive={isActive}>
      <FakeTitle>미제공 서비스</FakeTitle>
      <ServiceTitleWrapper>
        <ServiceTitle $color="#00000099">미제공 서비스</ServiceTitle>
        <ServiceSubText>아래 업무들은 서비스를 제공하지 않습니다.</ServiceSubText>
      </ServiceTitleWrapper>
      <ServiceList>
        <NoOfferItem>
          <NoOfferTextWrapper>
            <CheckCircle bgColor="#E5E5E5">{CheckCircleSvg}</CheckCircle>
            <ServiceText>이사, 입주청소 및 인테리어 전후</ServiceText>
          </NoOfferTextWrapper>
          <NoOfferReason>전문 도구와 2인 이상의 전문 인력이 필요한 특수 청소로 서비스 진행이 어렵습니다.</NoOfferReason>
        </NoOfferItem>
        <NoOfferItem>
          <NoOfferTextWrapper>
            <CheckCircle bgColor="#E5E5E5">{CheckCircleSvg}</CheckCircle>
            <ServiceText>TV, 컴퓨터 모니터 화면</ServiceText>
          </NoOfferTextWrapper>
          <NoOfferReason>파손, 변형 위험이 있어 진행이 어렵습니다.</NoOfferReason>
        </NoOfferItem>
        <NoOfferItem>
          <NoOfferTextWrapper>
            <CheckCircle bgColor="#E5E5E5">{CheckCircleSvg}</CheckCircle>
            <ServiceText>손이 닿지 않는 곳</ServiceText>
          </NoOfferTextWrapper>
          <NoOfferReason>낙상 위험이 있어 서비스 진행이 어렵습니다.</NoOfferReason>
        </NoOfferItem>
        <NoOfferItem>
          <NoOfferTextWrapper>
            <CheckCircle bgColor="#E5E5E5">{CheckCircleSvg}</CheckCircle>
            <ServiceText>바닥 전체 무릎 꿇고 손걸레질</ServiceText>
          </NoOfferTextWrapper>
          <NoOfferReason>청소기 및 막대걸레를 이용하여 진행해드립니다.</NoOfferReason>
        </NoOfferItem>
        <NoOfferItem>
          <NoOfferTextWrapper>
            <CheckCircle bgColor="#E5E5E5">{CheckCircleSvg}</CheckCircle>
            <ServiceText>전문 수납 정리 및 옷장 정리 </ServiceText>
          </NoOfferTextWrapper>
          <NoOfferReason>전문 도구와 다수의 전문 인력이 필요한 특수청소로 서비스 진행이 어렵습니다.</NoOfferReason>
        </NoOfferItem>
        <NoOfferItem>
          <NoOfferTextWrapper>
            <CheckCircle bgColor="#E5E5E5">{CheckCircleSvg}</CheckCircle>
            <ServiceText>특수 청소</ServiceText>
          </NoOfferTextWrapper>
          <NoOfferReason>창문 유리 / 결로에 의한 곰팡이 / 커튼 및 블라인드 / 전기 제품 내부 청소</NoOfferReason>
        </NoOfferItem>
        <NoOfferItem>
          <NoOfferTextWrapper>
            <CheckCircle bgColor="#E5E5E5">{CheckCircleSvg}</CheckCircle>
            <ServiceText>손빨래 및 빨래 삶기</ServiceText>
          </NoOfferTextWrapper>
          <NoOfferReason>파손, 변형 위험이 있어 진행이 어렵습니다.</NoOfferReason>
        </NoOfferItem>
        <NoOfferItem>
          <NoOfferTextWrapper>
            <CheckCircle bgColor="#E5E5E5">{CheckCircleSvg}</CheckCircle>
            <ServiceText>청소 외의 가사업무</ServiceText>
          </NoOfferTextWrapper>
          <NoOfferReason>
            음식조리 및 상차리기 / 아이 돌봄 서비스 / 어르신 돌봄 서비스 / 반려동물 돌봄 및 배설물 청소 / 기타
            생활청소와 무관한 업무
          </NoOfferReason>
        </NoOfferItem>
      </ServiceList>
    </TabContent>
  );
};

const TabContent = styled.article<{ $isActive: boolean }>`
  position: relative;
  margin: 0 auto;
  max-width: ${({ theme }) => theme.brandSitesV2!.containerWidths!.desktop};

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    max-width: ${({ theme }) => theme.brandSitesV2!.containerWidths!.tablet};
  }

  display: none;
  ${({ $isActive }) =>
    $isActive &&
    css`
      display: block;
    `}
`;

const FakeTitle = styled.h1`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  margin: -1px;
  clip: rect(0, 0, 0, 0);
  text-indent: -5000px;
`;

const ServiceTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  align-items: center;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    margin-bottom: 20px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }
`;

const ServiceTitle = styled.h2<{ $color?: string }>`
  display: inline-block;
  color: ${({ $color }) => $color || '#00000066'};
  font-weight: 500;
  font-size: 19px;
  line-height: 140%;
  margin-right: 10px;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    font-size: 17px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    font-size: 14px;
    font-weight: 600;
  }
`;

const ServiceSubText = styled.p`
  font-weight: 300;
  font-size: 19px;
  line-height: 140%;
  color: rgba(0, 0, 0, 0.6);

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    font-size: 17px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    margin-top: 8px;
    font-size: 14px;
    font-weight: 400;
  }
`;

const ServiceList = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 26px;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    margin-bottom: 22px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    margin-bottom: 16px;
  }
`;

const ServiceItem = styled.li`
  flex: 0 0 50%;
  display: flex;
  flex-direction: row;
  margin-bottom: 14px;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    margin-bottom: 18px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    flex: 0 0 100%;
    margin-bottom: 14px;
  }
`;

const CheckCircle = styled.div<{ bgColor?: string }>`
  display: inline-block;
  width: 26px;
  height: 26px;
  position: relative;
  margin-right: 14px;
  margin-top: 4px;
  flex: 0 0 auto;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    width: 21px;
    height: 21px;
    margin-right: 8px;
    margin-top: 2px;
  }

  ${({ bgColor }) =>
    bgColor &&
    css`
      svg path {
        fill: ${bgColor};
      }
    `}
`;

const ServiceTextContainer = styled.div``;

const ServiceText = styled.p`
  font-weight: 300;
  font-size: 22px;
  line-height: 150%;
  color: rgba(0, 0, 0, 0.85);
  max-width: 440px;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    font-size: 19px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    font-size: 16px;
    font-weight: 400;
  }
`;

const ServiceDescription = styled.p`
  font-weight: 300;
  font-size: 20px;
  line-height: 150%;
  color: rgba(0, 0, 0, 0.6);
  max-width: 440px;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    font-size: 19px;
    max-width: 300px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    font-size: 16px;
    font-weight: 400;
  }
`;

const NoOfferItem = styled.div`
  flex: 0 0 50%;
  margin-bottom: 30px;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    /* margin-bottom: 18px; */
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    flex: 0 0 100%;
    margin-bottom: 20px;
  }
`;

const NoOfferTextWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const NoOfferReason = styled.p`
  margin-top: 8px;
  margin-left: 40px;
  font-weight: 300;
  font-size: 20px;
  line-height: 140%;
  color: rgba(0, 0, 0, 0.6);
  width: 80%;
  word-break: keep-all;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    margin-left: 29px;
    font-size: 17px;
    width: 85%;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    font-size: 14px;
    font-weight: 400;
  }
`;

const Information = styled.dl`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.03);
  padding: 12px 20px;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    padding: 12px;
  }
`;

const InfoDt = styled.dt`
  font-weight: 500;
  font-size: 21px;
  line-height: 140%;
  color: #00bdd6;
  margin-right: 10px;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    font-size: 16px;
    margin-right: 8px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    font-size: 14px;
    margin-right: 8px;
  }
`;

const InfoDd = styled.dd`
  font-weight: 300;
  font-size: 21px;
  line-height: 140%;
  color: rgba(0, 0, 0, 0.6);

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    font-size: 16px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    font-size: 14px;
    font-weight: 400;
  }
`;

const CheckCircleSvg = (
  <svg
    style={{ position: 'absolute', height: '100%', width: '100%', left: 0, top: 0 }}
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 25.999C20.1797 25.999 26 20.1787 26 12.999C26 5.81932 20.1797 -0.000976562 13 -0.000976562C5.8203 -0.000976562 0 5.81932 0 12.999C0 20.1787 5.8203 25.999 13 25.999Z"
      fill="#00BED6"
    />
    <path
      d="M8.13281 13.9754L11.4862 17.0543L17.8828 9.87012"
      stroke="white"
      strokeWidth="2.43474"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
